import { image } from '../../utils/helperQuery.wp';

// Single query for the whole site navigation. The `menu` tree feeds both the
// desktop and mobile (burger) navs; the option groups carry the desktop search
// labels and the mobile contact links.
export const navigationMainQuery = `
    menu(id: "navigation_main", idType: LOCATION) {
        id
        name
        menuItems(first: 100) {
            nodes {
                id
                label
                uri
                target
                parentId
                connectedNode {
                    node {
                        ... on NodeWithFeaturedImage {
                            featuredImage {
                                ${image}
                            }
                        }
                        ... on NodeWithExcerpt {
                            excerpt
                        }
                    }
                }
            }
        }
    }
    globalOptionsDefault {
        globalNavigationmain {
            global_navigationmain_labels {
                ariaLabel
                fieldGroupName
            }
            global_navigationmain_search {
                fieldGroupName
                subtitle
                title
            }
            global_navigationmain_applylink {
                target
                title
                url
            }
            global_navigationmain_contactlinks {
                link {
                    target
                    title
                    url
                }
            }
        }
    }
    generalSettings {
        title
    }
`;
